// extracted by mini-css-extract-plugin
var _1 = "ra-tab-basic";
var _2 = "ra-tab-basic-link-active";
var _3 = "ra-tab-basic-link";
var _4 = "ra-tab-basic-nav";
var _5 = "ra-tab-basic-pane-active";
var _6 = "ra-tab-basic-pane";
export { _1 as "tabBasicCls", _2 as "tabBasicLinkActiveCls", _3 as "tabBasicLinkCls", _4 as "tabBasicNavCls", _5 as "tabBasicPaneActiveCls", _6 as "tabBasicPaneCls" }
